export const stats = [
  {
    id: 'days',
    value: 115,
    label: 'Jours Ensemble',
    emoji: '📅',
    suffix: '',
    color: 'text-primary-pink'
  },
  {
    id: 'months',
    value: 6,
    label: 'Mois de Bonheur',
    emoji: '💕',
    suffix: '+',
    color: 'text-accent-pink'
  },
  {
    id: 'dates',
    value: 50,
    label: 'Dates Romantiques',
    emoji: '🌹',
    suffix: '',
    color: 'text-accent-coral'
  },
  {
    id: 'hours',
    value: 2400,
    label: 'Heures Ensemble',
    emoji: '⏰',
    suffix: '+',
    color: 'text-light-pink-300'
  },
  {
    id: 'messages',
    value: 15000,
    label: 'Messages Échangés',
    emoji: '💬',
    suffix: '+',
    color: 'text-primary-pink'
  },
  {
    id: 'reels',
    value: 10000,
    label: 'Reels Partagés',
    emoji: '🎬',
    suffix: '+',
    color: 'text-accent-pink'
  },
  {
    id: 'photos',
    value: 500,
    label: 'Photos de Souvenirs',
    emoji: '📸',
    suffix: '+',
    color: 'text-accent-coral'
  },
  {
    id: 'flowers',
    value: 12,
    label: 'Bouquets Offerts',
    emoji: '💐',
    suffix: '+',
    color: 'text-light-pink-300'
  }
]

export const compatibilityScores = [
  {
    id: 'emotional',
    label: 'Connexion Émotionnelle',
    value: 100,
    emoji: '❤️',
    color: '#E851B2'
  },
  {
    id: 'communication',
    label: 'Communication',
    value: 95,
    emoji: '💬',
    color: '#FF80BA'
  },
  {
    id: 'support',
    label: 'Soutien Mutuel',
    value: 100,
    emoji: '🤝',
    color: '#CE3798'
  },
  {
    id: 'fun',
    label: 'Fun Ensemble',
    value: 100,
    emoji: '😄',
    color: '#FFB6B3'
  }
]

export const talents = [
  {
    id: 'patisserie',
    title: 'Pâtisserie',
    description: 'Tes créations sucrées sont incroyables',
    emoji: '🧁'
  },
  {
    id: 'echecs',
    title: 'Échecs',
    description: 'Stratège redoutable',
    emoji: '♟️'
  },
  {
    id: 'rubiks',
    title: "Rubik's Cube",
    description: 'Résolu en un temps record',
    emoji: '🧩'
  }
]

export const values = [
  {
    id: 'faith',
    title: 'Foi',
    emoji: '🙏'
  },
  {
    id: 'love',
    title: 'Amour',
    emoji: '❤️'
  },
  {
    id: 'equality',
    title: 'Égalité',
    emoji: '⚖️'
  },
  {
    id: 'humor',
    title: 'Humour',
    emoji: '😂'
  }
]
